import { View, tokens } from "@sapphire-react/core";
import type { ReactNode } from "react";
import { colors } from "../styles/colors";

type Props = {
  children: ReactNode;
  height?: string;
  borderRadius?: string | number;
};

export function FormLayout({
  children,
  borderRadius = tokens.size.radiusSm.value,
  height = "auto",
}: Props) {
  return (
    <View
      paddingLeft={{ base: 12, sm: 16, md: 32 }}
      paddingRight={{ base: 12, sm: 16, md: 32 }}
      paddingTop={{ base: 24, md: 32 }}
      paddingBottom={{ base: 0, md: 32 }}
      flexDirection={"column"}
      backgroundColor={colors.sand50}
      borderRadius={borderRadius}
      height={height}
    >
      {children}
    </View>
  );
}
